import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
const LoadingAnimation = props => {
  const [delay, setDelay] = useState(() => props.delay > 0);
  useEffect(() => {
    if (delay) {
      const timeout = setTimeout(() => {
        setDelay(false);
      }, props.delay);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [delay]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, delay ? null : /*#__PURE__*/React.createElement("div", {
    className: "loader",
    style: props.style
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)));
};
LoadingAnimation.defaultProps = {
  delay: 0,
  style: {}
};
LoadingAnimation.propTypes = {
  delay: PropTypes.number,
  style: PropTypes.object
};
export default LoadingAnimation;
//# sourceMappingURL=LoadingAnimation.js.map